import { render } from "./Middle.vue?vue&type=template&id=1528e429"
import script from "./Middle.vue?vue&type=script&lang=js"
export * from "./Middle.vue?vue&type=script&lang=js"

import "./Middle.vue?vue&type=style&index=0&id=1528e429&lang=scss"

import exportComponent from "/home/runner/work/polissonos-web/polissonos-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__